import { createContext, useContext } from 'react';
import { ItemListOptionMetadata } from './item-context-types';

interface SearchNoteActionsContextType {
  onNotePress: (itemMetadata: ItemListOptionMetadata) => void;
}

/*
  Meant to provide context from unified search screen (desktop) to ItemDetailActions to show note/essential item actions.
  Otherwise, would need to prop drill 5+ levels for ItemDetailActions to conditionally render note/essential item actions only in unified search
*/
const SearchNoteActionsContext =
  createContext<SearchNoteActionsContextType | null>(null);

export const SearchNoteActionsProvider = SearchNoteActionsContext.Provider;
export const useSearchNoteActionsContext = () =>
  useContext(SearchNoteActionsContext);
